/* REACT */
import React, { useEffect, useState, lazy, Suspense } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'

/* @ts-ignore */

/* COMPONENTS */
import Widget from './Widget'

/* STORE */
import { resetAppState } from './store/general/actions'
import { setSocketListeners } from './store/maya/actions'

/* STYLES */

/* UTILS/CONSTANTS */
import {
  logToConsole,
  SocketsClass,
  openMayaPopoverChat,
  addMayaPopoverNotification,
} from './utils'

/* LAZY LOADED CLIENT COMPONENTS */

/* ASSETS */

function App({
  organizationKey,
  organizationSlug,
  language,
  widgetMode = 'full-page',
  chatMode = 'b2c',
  usageMode,
  brand = null,
}: {
  organizationKey: string
  organizationSlug: string
  language: string
  widgetMode: string
  chatMode: string
  usageMode?: string
  brand?: string | null
}) {
  const [key, setKey] = useState(0) // Key to force re-render

  useEffect(() => {
    if (window) {
      // EXPOSE FUNCTION TO WINDOW FOR OUR CLIENTS TO OPEN THE MAYA POPOVER CHAT
      // @ts-ignore
      window.openMayaPopoverChat = openMayaPopoverChat

      // EXPOSE FUNCTION TO WINDOW FOR OUR CLIENTS TO ADD A POPOVER NOTIFICATION MESSAGE
      // @ts-ignore
      window.addMayaPopoverNotification = addMayaPopoverNotification
    }
  }, [])

  useEffect(() => {
    logToConsole('Maya App => Mounted!')
    let socketListenersAlreadySet = false
    setSocketListeners()

    if (widgetMode === 'full-page' || widgetMode === 'popover') {
      const handlePageShow = (event: any) => {
        logToConsole(
          'Back button navigation => pageshow event triggered!',
          event
        )

        if (event.persisted) {
          logToConsole(
            'Back button navigation => Page was restored from the cache!'
          )

          // RESET APP STATE
          logToConsole('Back button navigation => Resetting app state!')
          resetAppState()

          // RESET SOCKETS
          socketListenersAlreadySet = true

          /* @ts-ignore */
          SocketsClass.getInstance().reset()

          // UPDATE STATE SO THAT WIDGET RE RENDERS
          setTimeout(() => {
            logToConsole('Back button navigation => Update app state key!')
            setKey(prevKey => prevKey + 1) // Increment key to force re-mounting of the widget
            setSocketListeners()
          }, 500)
        }
      }

      window.addEventListener('pageshow', handlePageShow)

      return () => {
        window.removeEventListener('pageshow', handlePageShow)
      }
    }
  }, [])

  return (
    <Widget
      key={key} // Pass the key to force the component to unmount and mount again
      organizationKey={organizationKey}
      organizationSlug={organizationSlug}
      language={language}
      widgetMode={widgetMode}
      chatMode={chatMode}
      usageMode={usageMode}
      brand={brand}
    />
  )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(App)
